export function processFloat(val: number | string): number {
  // fix issues with how JS handles floats for grids. (GPA-3200)
  // example: 0.1 + 0.2 = 0.30000000000000004
  // By passing floats through this function you get what you expected
  // example: 0.1 + 0.2 = 0.3
  return Number(parseFloat(`${val}`).toPrecision(12));
}
